module.exports = __webpack_public_path__ + "static/media/carrossel3.ebbbc644.jpg";